import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect
        width="29"
        height="29"
        x="1.5"
        y="1.5"
        stroke="#fff"
        strokeWidth="3"
        rx="14.5"
      ></rect>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 20.571h12M10 16h12m-12-4.572h12"
      ></path>
    </svg>
  );
}

export default Icon;
